<template>
  <div class="columns is-multiline">
    <b-field :label="$t('demandeLogistique.creationOrUpdate.datePlanification')"
             class="column is-narrow mgb-0 obligatoire">
      <b-datepicker
            show-week-number
            icon="calendar-today"
            v-model="creationDemandeParametre.datePlanification"
            nearby-selectable-month-days
            editable
            @input="selectDatePlanification">
        </b-datepicker>
    </b-field>
    <b-field :label="$t('demandeLogistique.creationOrUpdate.actionLogistique')"
             class="column is-12 mgb-0 obligatoire">
      <b-input v-model="creationDemandeParametre.actionLogistique"
        type="textarea" maxlength="255">
      </b-input>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    creationDemandeParametre: {
      type: Object,
      required: true,
    },
  },
  methods: {
    selectDatePlanification(val) {
      this.$emit('onDatePlanificationChange', val);
    },
  },
};
</script>
